import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { CATTLE_CATEGORIES } from '../constants/cattle.constants';
import { CattleListQuery } from '../queries/cattle.query';
import ListRow from './ListRow';
import Loader from "../../common/components/Loader/Loader";
import ErrorFetch from "../../common/components/Error/ErrorFetch";

class CattleList extends Component {
  state = { selectedCategory: 'ALL'};

  handleTypeSelect = ({ target }) =>
    this.setState({ selectedCategory: target.value });

  render() {
    const { selectedCategory } = this.state;
    const categoryCode = selectedCategory === 'ALL' ?
      undefined : selectedCategory;
    return [
      <select
        className="select"
        onChange={this.handleTypeSelect}
        value={this.state.selectedCategory}
      >
        <option value="ALL">Visos kategorijos</option>
        {CATTLE_CATEGORIES.map(item => (
          <option
            key={`seedTypeOption${item.type}`}
            value={item.type}
            onChange={this.handleTypeSelect}
          >
            {item.label}
          </option>
        ))}
      </select>,
      <div className="ListItemsContainer">
        <table className="table" align="center">
          <tbody>
            <tr>
              <td className="text-left">
                <strong>Prekė</strong>
              </td>
              <td>
                <strong>Norma</strong>
              </td>
              <td>
                <strong>Kaina (vnt.)</strong>
              </td>
              {/*<td />*/}
            </tr>
            <Query
              query={CattleListQuery}
              variables={{ categoryCode }}
            >
              {({ loading, data }) => loading ? <tr><td colSpan="3"><Loader /></td></tr> :
                !data || !data.cattleProducts ? <tr><td colSpan="3"><ErrorFetch /></td></tr> :
                data.cattleProducts.map(item => (<ListRow product={item} type="cattle" />))
              }
            </Query>
          </tbody>
        </table>
      </div>
    ]
  }

}

export default CattleList;
